module.exports = __webpack_public_path__ + "static/media/rsz-oz.59418961.jpg";